$(document).ready(function() {
    if ($('#calendar').length > 0) {
        $('#calendar .header .right').click();
        $('#calendar .header .left').click();
    }

    if ($.fn.multiselect && $('.multiselect').length) {
        $('.multiselect').multiselect({
            includeSelectAllOption: true,
            maxHeight: 250,
        });
    }

    $('.fromGPSPosition').click(function() {
        $(this).closest('form').find('.fromCities').addClass('d-none');
        $(this).closest('form').find('.fromGPS').removeClass('d-none');
    });

    $('.fromCity').click(function() {
        $(this).closest('form').find('.fromGPS').addClass('d-none');
        $(this).closest('form').find('.fromCities').removeClass('d-none');
    });

    $('.getGPSPosition').click(function() {
        $('.getGPSPosition i').show();
        $('.getGPSPosition span').text('wird bestimmt');
        getLocation();
    });


    // Push Notification Stuff START +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

    async function initNotifications() {
        const permission = await Notification.requestPermission();
        console.log('Notification permission:', permission);
    }


    $('#savePushSettings').click(function () {
        pushDatas = [];
        pushDatas['app'] = true;
        tokenValue  = $('meta[name=csrf-token]').attr('content');
        if ($('#enabledNotifications').length > 0) {
            pushDatas['enabled'] = $('#enabledNotifications').is(':checked');
            if (pushDatas['enabled'] == false) {
                pushDatas['disabled'] = true;
            } else {
                pushDatas['disabled'] = false;
            }
        } else {
            pushDatas['enabled'] = true;
        }
        pushDatas['concertsThisWeek'] = $('#concertsThisWeek').is(':checked');
        pushDatas['thisWeekendFriday'] = $('#thisWeekendFriday').is(':checked');
        pushDatas['thisWeekendSaturday'] = $('#thisWeekendSaturday').is(':checked');
        pushDatas['recommendations'] = $('#recommendations').is(':checked');
        updateNotificationSessionData(pushDatas, tokenValue);
        $(this).closest('.modal').find("[data-dismiss=modal]:not(.naTrigger)").trigger({ type: "click" });
    });

    $('.pushNotifications').click(function() {
        // open Notification Modal
        $('#notificationSettings').modal('show');
    });

    // Push Notification Stuff END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

    function getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(setPosition);
        } else {
            $('#gpsLatitude').text('Geolocation gehen in deinem Browser nicht');
            $('.getGPSPosition i').hide();
        }
    }

    function setPosition(position) {
        $('.getGPSPosition span').text('gesetzt');
        $('.getGPSPosition i').hide();
        $('#setGPSPositionFirst').hide();
        $('.gpsLatitude').text(position.coords.latitude);
        $('.gpsLongitude').text(position.coords.longitude);
        $('.lat').val(position.coords.latitude);
        $('.lon').val(position.coords.longitude);

        $('.getGPSPosition').addClass('setted').removeClass('unsetted');
    }

    if ($('.eventFilterView').length > 0) {
        if (datasFromPosition == 'gps') {
            $('#fromGPSPosition_page').click();
        } else if (datasFromPosition == 'city') {
            $('#fromCity_page').click();
        }
        if ($.fn.multiselect) {
            $('#location_page').multiselect('select', datasLocations);
            $('#genres_page').multiselect('select', datasGenres);
        }
    }

    $("form.eventFilterView").on("submit", function (e) {
        origin = $(this).data('origin');
        actPositionValue = $('#search_'+origin).find('input[name=fromPosition]:checked').val();

        if (actPositionValue == 'gps') {
            if ($('.lat').val() != '' && $('.lon').val() != '') {
                // later cleaner
            } else {
                e.preventDefault();
                emptyGPS();
                $('#setGPSPositionFirst').show();
            }
        }
    });

    function emptyGPS(){
        $('.getGPSPosition').addClass('shake2Times');
        window.setTimeout(removeAnimation,2000);
    }

    function removeAnimation(e){
        $('.getGPSPosition').removeClass('shake2Times');
    };

    $('#searchEvent').on('show.bs.modal', function (event) {
        cityId = $(event.relatedTarget).attr('data-city');
        if (cityId != null) {
            $('#fromCity_modal').click();
            $('#fromCities_modal #city_modal option').removeAttr('selected');
            $('#fromCities_modal #city_modal option[value="'+cityId+'"]').prop("selected", true).attr("selected", true);
        }
        if ($('#range_modal').val() == '') {
            $('#range_modal').val(10);
        }
    });
});

function convertTableToJSON(table) {
    let keys = table.shift();
    let json = table.map(row => Object.assign({}, ...row.map((v, i) => ({ [keys[i]]: v }))));
    return json
}

if($('#appISCLink').length > 0) {
    var icsFile = null;
    eventStartDate = $('#eventStartDate').val();
    eventEndDate = $('#eventEndDate').val();
    title = $('.box-about-mega-title').text();
    content = $('.mainContentFromEvent').text();
    createICSFile(eventStartDate,eventEndDate,title,content);
}

// createFile('2023-02-02T12:00:00', 'test','blablabla');

function createICSFile(eventStartDate,eventEndDate,title,description) {
    var eventDate = {
        start: Date(eventStartDate),
        end: Date(eventEndDate)
    },
        summary =  title,
        description = description;
    icsFile = makeIcsFile(eventDate, summary, description);
    $('#appISCLink').attr('href',icsFile);
}

function convertDate(date) {
    var event = new Date(date).toISOString();
    event = event.split("T")[0];
    event = event.split("-");
    event = event.join("");
    return event;
}

function makeIcsFile(date, summary, description) {
    var test =
        "BEGIN:VCALENDAR\n" +
        "CALSCALE:GREGORIAN\n" +
        "METHOD:PUBLISH\n" +
        "PRODID:-//Test Cal//EN\n" +
        "VERSION:2.0\n" +
        "BEGIN:VEVENT\n" +
        "UID:test-1\n" +
        "DTSTART;VALUE=DATE:" +
        convertDate(date.start) +
        "\n" +
        "DTEND;VALUE=DATE:" +
        convertDate(date.end) +
        "\n" +
        "SUMMARY:" +
        summary +
        "\n" +
        "DESCRIPTION:" +
        description +
        "\n" +
        "END:VEVENT\n" +
        "END:VCALENDAR";

    var data = new File([test], { type: "text/plain" });

    // If we are replacing a previously generated file we need to
    // manually revoke the object URL to avoid memory leaks.
    if (icsFile !== null) {
        window.URL.revokeObjectURL(icsFile);
    }

    icsFile = window.URL.createObjectURL(data);

    return icsFile;
}


/* VENDOR STUFF */
"use strict";
(function () {
    // Global variables
    var
        userAgent = navigator.userAgent.toLowerCase(),
        initialDate = new Date(),

        $document = $(document),
        $window = $(window),
        $html = $("html"),
        $body = $("body"),

        isDesktop = $html.hasClass("desktop"),
        isIE = userAgent.indexOf("msie") !== -1 ? parseInt(userAgent.split("msie")[1], 10) : userAgent.indexOf("trident") !== -1 ? 11 : userAgent.indexOf("edge") !== -1 ? 12 : false,
        isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
        windowReady = false,
        isNoviBuilder = false,
        livedemo = true,

        plugins = {
            bootstrapTooltip:        $( '[data-toggle="tooltip"]' ),
            bootstrapModalDialog:    $( '.modal' ),
            customToggle:            $( '[data-custom-toggle]' ),
            counter:                 $( '.counter' ),
            circleProgress:          $( '.progress-bar-circle' ),
            captcha:                 $( '.recaptcha' ),
            campaignMonitor:         $( '.campaign-mailform' ),
            copyrightYear:           $( '.copyright-year' ),
            checkbox:                $( 'input[type="checkbox"]' ),
            dateCountdown:           $( '.DateCountdown' ),
            lightGallery:            $( '[data-lightgallery="group"]' ),
            lightGalleryItem:        $( '[data-lightgallery="item"]' ),
            lightDynamicGalleryItem: $( '[data-lightgallery="dynamic"]' ),
            materialParallax:        $( '.parallax-container' ),
            owl:                     $( '.owl-carousel' ),
            popover:                 $( '[data-toggle="popover"]' ),
            progressLinear:          $( '.progress-linear' ),
            preloader:               $( '.preloader' ),
            rdNavbar:                $( '.rd-navbar' ),
            rdMailForm:              $( '.rd-mailform' ),
            rdInputLabel:            $( '.form-label' ),
            regula:                  $( '[data-constraints]' ),
            radio:                   $( 'input[type="radio"]' ),
            swiper:                  $( '.swiper-container' ),
            search:                  $( '.rd-search' ),
            searchResults:           $( '.rd-search-results' ),
            statefulButton:          $( '.btn-stateful' ),
            viewAnimate:             $( '.view-animate' ),
            wow:                     $( '.wow' ),
            scroller:                $( '.scroll-wrap' ),
            countDown:               $( '.countdown' ),
            stepper:                 $( 'input[type="number"]' ),
            slick:                   $( '.slick-slider' ),
            vide:                    $( '.bg-vide' ),
            customWaypoints:         $('[data-custom-scroll-to]'),
        };

    /**
     * @desc Check the element was been scrolled into the view
     * @param {object} elem - jQuery object
     * @return {boolean}
     */
    function isScrolledIntoView ( elem ) {
        if ( isNoviBuilder ) return true;
        return elem.offset().top + elem.outerHeight() >= $window.scrollTop() && elem.offset().top <= $window.scrollTop() + $window.height();
    }

    /**
     * @desc Calls a function when element has been scrolled into the view
     * @param {object} element - jQuery object
     * @param {function} func - init function
     */
    function lazyInit( element, func ) {
        var scrollHandler = function () {
            if ( ( !element.hasClass( 'lazy-loaded' ) && ( isScrolledIntoView( element ) ) ) ) {
                func.call();
                element.addClass( 'lazy-loaded' );
            }
        };

        scrollHandler();
        $window.on( 'scroll', scrollHandler );
    }

    // Initialize scripts that require a loaded window
    $window.on('load', function () {
        // Page loader & Page transition
        if (plugins.preloader.length && !isNoviBuilder) {
            pageTransition({
                target: document.querySelector( '.page' ),
                delay: 0,
                duration: 500,
                classIn: 'fadeIn',
                classOut: 'fadeOut',
                classActive: 'animated',
                conditions: function (event, link) {
                    return link && !/(\#|javascript:void\(0\)|javascript:;|callto:|tel:|mailto:|:\/\/)/.test(link) && !event.currentTarget.hasAttribute('data-lightgallery');
                },
                onTransitionStart: function ( options ) {
                    setTimeout( function () {
                        plugins.preloader.removeClass('loaded');
                    }, options.duration * .75 );
                },
                onReady: function () {
                    plugins.preloader.addClass('loaded');
                    windowReady = true;
                }
            });
        }

        // jQuery Count To
        if ( plugins.counter.length ) {
            for ( var i = 0; i < plugins.counter.length; i++ ) {
                var
                    counter = $(plugins.counter[i]),
                    initCount = function () {
                        var counter = $(this);
                        if ( !counter.hasClass( "animated-first" ) && isScrolledIntoView( counter ) ) {
                            counter.countTo({
                                refreshInterval: 40,
                                speed: counter.attr("data-speed") || 1000,
                                from: 0,
                                to: parseInt( counter.text(), 10 )
                            });
                            counter.addClass('animated-first');
                        }
                    };

                $.proxy( initCount, counter )();
                $window.on( "scroll", $.proxy( initCount, counter ) );
            }
        }

        // Progress bar
        if ( plugins.progressLinear.length ) {
            for ( var i = 0; i < plugins.progressLinear.length; i++) {
                var
                    bar = $(plugins.progressLinear[i]),
                    initProgress = function() {
                        var
                            bar = $(this),
                            end = parseInt($(this).find('.progress-value').text(), 10);

                        if ( !bar.hasClass( "animated-first" ) && isScrolledIntoView( bar ) ) {
                            bar.find('.progress-bar-linear').css({width: end + '%'});
                            bar.find('.progress-value').countTo({
                                refreshInterval: 40,
                                from: 0,
                                to: end,
                                speed: 1000
                            });
                            bar.addClass('animated-first');
                        }
                    };

                $.proxy( initProgress, bar )();
                $window.on( "scroll", $.proxy( initProgress, bar ) );
            }
        }

        // Circle Progress
        if ( plugins.circleProgress.length ) {
            for ( var i = 0; i < plugins.circleProgress.length; i++ ) {
                var circle = $(plugins.circleProgress[i]);

                circle.circleProgress({
                    value: circle.attr('data-value'),
                    size: circle.attr('data-size') ? circle.attr('data-size') : 175,
                    fill: {
                        gradient: circle.attr('data-gradient').split(","),
                        gradientAngle: Math.PI / 4
                    },
                    startAngle: -Math.PI / 4 * 2,
                    emptyFill: circle.attr('data-empty-fill') ? circle.attr('data-empty-fill') : "rgb(245,245,245)"
                }).on('circle-animation-progress', function (event, progress, stepValue) {
                    $(this).find('span').text( String(stepValue.toFixed(2)).replace('0.', '').replace('1.', '1') );
                });

                if ( isScrolledIntoView( circle ) ) circle.addClass('animated-first');

                $window.on( 'scroll', $.proxy( function() {
                    var circle = $(this);
                    if ( !circle.hasClass( "animated-first" ) && isScrolledIntoView( circle ) ) {
                        circle.circleProgress( 'redraw' );
                        circle.addClass( 'animated-first' );
                    }
                }, circle ) );
            }
        }

        // Isotope
        if (plugins.isotope && plugins.isotope.length) {
            for ( var i = 0; i < plugins.isotope.length; i++ ) {
                var
                    wrap = plugins.isotope[ i ],
                    filterHandler = function ( event ) {
                        event.preventDefault();
                        for ( var n = 0; n < this.isoGroup.filters.length; n++ ) this.isoGroup.filters[ n ].classList.remove( 'active' );
                        this.classList.add( 'active' );
                        this.isoGroup.isotope.arrange( { filter: this.getAttribute( "data-isotope-filter" ) !== '*' ? '[data-filter*="' + this.getAttribute( "data-isotope-filter" ) + '"]' : '*' } );
                    },
                    resizeHandler = function () {
                        this.isoGroup.isotope.layout();
                    };

                wrap.isoGroup = {};
                wrap.isoGroup.filters = wrap.querySelectorAll( '[data-isotope-filter]' );
                wrap.isoGroup.node = wrap.querySelector( '.isotope' );
                wrap.isoGroup.layout = wrap.isoGroup.node.getAttribute( 'data-isotope-layout' ) ? wrap.isoGroup.node.getAttribute( 'data-isotope-layout' ) : 'masonry';
                wrap.isoGroup.isotope = new Isotope( wrap.isoGroup.node, {
                    itemSelector: '.isotope-item',
                    layoutMode: wrap.isoGroup.layout,
                    filter: '*',
                    columnWidth: ( function() {
                        if ( wrap.isoGroup.node.hasAttribute('data-column-class') ) return wrap.isoGroup.node.getAttribute('data-column-class');
                        if ( wrap.isoGroup.node.hasAttribute('data-column-width') ) return parseFloat( wrap.isoGroup.node.getAttribute('data-column-width') );
                    }() )
                } );

                for ( var n = 0; n < wrap.isoGroup.filters.length; n++ ) {
                    var filter = wrap.isoGroup.filters[ n ];
                    filter.isoGroup = wrap.isoGroup;
                    filter.addEventListener( 'click', filterHandler );
                }

                window.addEventListener( 'resize', resizeHandler.bind( wrap ) );
            }
        }

        // Material Parallax
        if ( plugins.materialParallax.length ) {
            if ( !isNoviBuilder && !isIE && !isMobile) {
                plugins.materialParallax.parallax();
            } else {
                for ( var i = 0; i < plugins.materialParallax.length; i++ ) {
                    var $parallax = $(plugins.materialParallax[i]);

                    $parallax.addClass( 'parallax-disabled' );
                    $parallax.css({ "background-image": 'url('+ $parallax.data("parallax-img") +')' });
                }
            }
        }
    });

    // Initialize scripts that require a finished document
    $(function () {
        isNoviBuilder = window.xMode;

        /**
         * jpFormatePlaylistObj
         * @description  format dynamic playlist object for jPlayer init
         */
        function jpFormatePlaylistObj(playlistHtml) {
            var playlistObj = [];

            // Format object with audio
            for (var i = 0; i < playlistHtml.length; i++) {
                var playlistItem = playlistHtml[i],
                    itemData = $(playlistItem).data();
                playlistObj[i] = {};

                for (var key in itemData) {
                    playlistObj[i][key.replace('jp', '').toLowerCase()] = itemData[key];
                }
            }

            return playlistObj;
        }

        /**
         * initJplayerBase
         * @description Base jPlayer init
         */
        function initJplayerBase(index, item, mediaObj) {
            return new jPlayerPlaylist({
                jPlayer: item.getElementsByClassName("jp-jplayer")[0],
                cssSelectorAncestor: ".jp-audio-" + index // Need too bee a selector not HTMLElement or Jq object, so we make it unique
            }, mediaObj, {
                playlistOptions: {
                    enableRemoveControls: false
                },
                supplied: "ogv, m4v, oga, mp3",
                useStateClassSkin: true,
                volume: 0.4
            });
        }

        /**
         * @desc Toggle swiper videos on active slides
         * @param {object} swiper - swiper slider
         */
        function toggleSwiperInnerVideos(swiper) {
            var prevSlide = $(swiper.slides[swiper.previousIndex]),
                nextSlide = $(swiper.slides[swiper.activeIndex]),
                videos,
                videoItems = prevSlide.find("video");

            for (var i = 0; i < videoItems.length; i++) {
                videoItems[i].pause();
            }

            videos = nextSlide.find("video");
            if (videos.length) {
                videos.get(0).play();
            }
        }

        /**
         * @desc Toggle swiper animations on active slides
         * @param {object} swiper - swiper slider
         */
        function toggleSwiperCaptionAnimation(swiper) {
            var prevSlide = $(swiper.container).find("[data-caption-animate]"),
                nextSlide = $(swiper.slides[swiper.activeIndex]).find("[data-caption-animate]"),
                delay,
                duration,
                nextSlideItem,
                prevSlideItem;

            for (var i = 0; i < prevSlide.length; i++) {
                prevSlideItem = $(prevSlide[i]);

                prevSlideItem.removeClass("animated")
                    .removeClass(prevSlideItem.attr("data-caption-animate"))
                    .addClass("not-animated");
            }


            var tempFunction = function (nextSlideItem, duration) {
                return function () {
                    nextSlideItem
                        .removeClass("not-animated")
                        .addClass(nextSlideItem.attr("data-caption-animate"))
                        .addClass("animated");
                    if (duration) {
                        nextSlideItem.css('animation-duration', duration + 'ms');
                    }
                };
            };

            for (var i = 0; i < nextSlide.length; i++) {
                nextSlideItem = $(nextSlide[i]);
                delay = nextSlideItem.attr("data-caption-delay");
                duration = nextSlideItem.attr('data-caption-duration');
                if (!isNoviBuilder) {
                    if (delay) {
                        setTimeout(tempFunction(nextSlideItem, duration), parseInt(delay, 10));
                    } else {
                        tempFunction(nextSlideItem, duration);
                    }

                } else {
                    nextSlideItem.removeClass("not-animated")
                }
            }
        }

        /**
         * @desc Initialize owl carousel plugin
         * @param {object} carousel - carousel jQuery object
         */
        function initOwlCarousel ( carousel ) {
            var
                aliaces = [ '-', '-sm-', '-md-', '-lg-', '-xl-', '-xxl-' ],
                values = [ 0, 576, 768, 992, 1200, 1600 ],
                responsive = {};

            for ( var j = 0; j < values.length; j++ ) {
                responsive[ values[ j ] ] = {};
                for ( var k = j; k >= -1; k-- ) {
                    if ( !responsive[ values[ j ] ][ 'items' ] && carousel.attr( 'data' + aliaces[ k ] + 'items' ) ) {
                        responsive[ values[ j ] ][ 'items' ] = k < 0 ? 1 : parseInt( carousel.attr( 'data' + aliaces[ k ] + 'items' ), 10 );
                    }
                    if ( !responsive[ values[ j ] ][ 'stagePadding' ] && responsive[ values[ j ] ][ 'stagePadding' ] !== 0 && carousel.attr( 'data' + aliaces[ k ] + 'stage-padding' ) ) {
                        responsive[ values[ j ] ][ 'stagePadding' ] = k < 0 ? 0 : parseInt( carousel.attr( 'data' + aliaces[ k ] + 'stage-padding' ), 10 );
                    }
                    if ( !responsive[ values[ j ] ][ 'margin' ] && responsive[ values[ j ] ][ 'margin' ] !== 0 && carousel.attr( 'data' + aliaces[ k ] + 'margin' ) ) {
                        responsive[ values[ j ] ][ 'margin' ] = k < 0 ? 30 : parseInt( carousel.attr( 'data' + aliaces[ k ] + 'margin' ), 10 );
                    }
                }
            }

            // Enable custom pagination
            if ( carousel.attr( 'data-dots-custom' ) ) {
                carousel.on( 'initialized.owl.carousel', function ( event ) {
                    var
                        carousel = $( event.currentTarget ),
                        customPag = $( carousel.attr( 'data-dots-custom' ) ),
                        active = 0;

                    if ( carousel.attr( 'data-active' ) ) {
                        active = parseInt( carousel.attr( 'data-active' ), 10 );
                    }

                    carousel.trigger( 'to.owl.carousel', [ active, 300, true ] );
                    customPag.find( '[data-owl-item="' + active + '"]' ).addClass( 'active' );

                    customPag.find( '[data-owl-item]' ).on( 'click', function ( event ) {
                        event.preventDefault();
                        carousel.trigger( 'to.owl.carousel', [ parseInt( this.getAttribute( 'data-owl-item' ), 10 ), 300, true ] );
                    } );

                    carousel.on( 'translate.owl.carousel', function ( event ) {
                        customPag.find( '.active' ).removeClass( 'active' );
                        customPag.find( '[data-owl-item="' + event.item.index + '"]' ).addClass( 'active' )
                    } );
                } );
            }

            // Initialize lightgallery items in cloned owl items
            carousel.on( 'initialized.owl.carousel', function () {
                initLightGalleryItem( carousel.find( '[data-lightgallery="item"]' ), 'lightGallery-in-carousel' );
            } );

            carousel.owlCarousel( {
                autoplay:           isNoviBuilder ? false : carousel.attr( 'data-autoplay' ) !== 'false',
                autoplayTimeout:    carousel.attr( "data-autoplay" ) ? Number( carousel.attr( "data-autoplay" ) ) : 3000,
                autoplayHoverPause: true,
                loop:               isNoviBuilder ? false : carousel.attr( 'data-loop' ) !== 'false',
                items:              1,
                center:             carousel.attr( 'data-center' ) === 'true',
                dotsContainer:      carousel.attr( 'data-pagination-class' ) || false,
                navContainer:       carousel.attr( 'data-navigation-class' ) || false,
                mouseDrag:          isNoviBuilder ? false : carousel.attr( 'data-mouse-drag' ) !== 'false',
                nav:                carousel.attr( 'data-nav' ) === 'true',
                dots:               carousel.attr( 'data-dots' ) === 'true',
                dotsEach:           carousel.attr( 'data-dots-each' ) ? parseInt( carousel.attr( 'data-dots-each' ), 10 ) : false,
                animateIn:          carousel.attr( 'data-animation-in' ) ? carousel.attr( 'data-animation-in' ) : false,
                animateOut:         carousel.attr( 'data-animation-out' ) ? carousel.attr( 'data-animation-out' ) : false,
                responsive:         responsive,
                navText:            carousel.attr( 'data-nav-text' ) ? $.parseJSON( carousel.attr( 'data-nav-text' ) ) : [],
                navClass:           carousel.attr( 'data-nav-class' ) ? $.parseJSON( carousel.attr( 'data-nav-class' ) ) : [ 'owl-prev', 'owl-next' ]
            } );
        }

        /**
         * @desc Create live search results
         * @param {object} options
         */
        function liveSearch(options) {
            $('#' + options.live).removeClass('cleared').html();
            options.current++;
            options.spin.addClass('loading');
            $.get(handler, {
                s: decodeURI(options.term),
                liveSearch: options.live,
                dataType: "html",
                liveCount: options.liveCount,
                filter: options.filter,
                template: options.template
            }, function (data) {
                options.processed++;
                var live = $('#' + options.live);
                if ((options.processed === options.current) && !live.hasClass('cleared')) {
                    live.find('> #search-results').removeClass('active');
                    live.html(data);
                    setTimeout(function () {
                        live.find('> #search-results').addClass('active');
                    }, 50);
                }
                options.spin.parents('.rd-search').find('.input-group-addon').removeClass('loading');
            })
        }

        /**
         * @desc Attach form validation to elements
         * @param {object} elements - jQuery object
         */
        function attachFormValidator(elements) {
            // Custom validator - phone number
            regula.custom({
                name: 'PhoneNumber',
                defaultMessage: 'Invalid phone number format',
                validator: function() {
                    if ( this.value === '' ) return true;
                    else return /^(\+\d)?[0-9\-\(\) ]{5,}$/i.test( this.value );
                }
            });

            for (var i = 0; i < elements.length; i++) {
                var o = $(elements[i]), v;
                o.addClass("form-control-has-validation").after("<span class='form-validation'></span>");
                v = o.parent().find(".form-validation");
                if (v.is(":last-child")) o.addClass("form-control-last-child");
            }

            elements.on('input change propertychange blur', function (e) {
                var $this = $(this), results;

                if (e.type !== "blur") if (!$this.parent().hasClass("has-error")) return;
                if ($this.parents('.rd-mailform').hasClass('success')) return;

                if (( results = $this.regula('validate') ).length) {
                    for (i = 0; i < results.length; i++) {
                        $this.siblings(".form-validation").text(results[i].message).parent().addClass("has-error");
                    }
                } else {
                    $this.siblings(".form-validation").text("").parent().removeClass("has-error")
                }
            }).regula('bind');

            var regularConstraintsMessages = [
                {
                    type: regula.Constraint.Required,
                    newMessage: "The text field is required."
                },
                {
                    type: regula.Constraint.Email,
                    newMessage: "The email is not a valid email."
                },
                {
                    type: regula.Constraint.Numeric,
                    newMessage: "Only numbers are required"
                },
                {
                    type: regula.Constraint.Selected,
                    newMessage: "Please choose an option."
                }
            ];


            for (var i = 0; i < regularConstraintsMessages.length; i++) {
                var regularConstraint = regularConstraintsMessages[i];

                regula.override({
                    constraintType: regularConstraint.type,
                    defaultMessage: regularConstraint.newMessage
                });
            }
        }

        /**
         * @desc Check if all elements pass validation
         * @param {object} elements - object of items for validation
         * @param {object} captcha - captcha object for validation
         * @return {boolean}
         */
        function isValidated(elements, captcha) {
            var results, errors = 0;

            if (elements.length) {
                for (var j = 0; j < elements.length; j++) {

                    var $input = $(elements[j]);
                    if ((results = $input.regula('validate')).length) {
                        for (k = 0; k < results.length; k++) {
                            errors++;
                            $input.siblings(".form-validation").text(results[k].message).parent().addClass("has-error");
                        }
                    } else {
                        $input.siblings(".form-validation").text("").parent().removeClass("has-error")
                    }
                }

                if (captcha) {
                    if (captcha.length) {
                        return validateReCaptcha(captcha) && errors === 0
                    }
                }

                return errors === 0;
            }
            return true;
        }

        /**
         * @desc Validate google reCaptcha
         * @param {object} captcha - captcha object for validation
         * @return {boolean}
         */
        function validateReCaptcha(captcha) {
            var captchaToken = captcha.find('.g-recaptcha-response').val();

            if (captchaToken.length === 0) {
                captcha
                    .siblings('.form-validation')
                    .html('Please, prove that you are not robot.')
                    .addClass('active');
                captcha
                    .closest('.form-wrap')
                    .addClass('has-error');

                captcha.on('propertychange', function () {
                    var $this = $(this),
                        captchaToken = $this.find('.g-recaptcha-response').val();

                    if (captchaToken.length > 0) {
                        $this
                            .closest('.form-wrap')
                            .removeClass('has-error');
                        $this
                            .siblings('.form-validation')
                            .removeClass('active')
                            .html('');
                        $this.off('propertychange');
                    }
                });

                return false;
            }

            return true;
        }

        /**
         * @desc Initialize Google reCaptcha
         */
        window.onloadCaptchaCallback = function () {
            for (var i = 0; i < plugins.captcha.length; i++) {
                var $capthcaItem = $(plugins.captcha[i]);

                grecaptcha.render(
                    $capthcaItem.attr('id'),
                    {
                        sitekey: $capthcaItem.attr('data-sitekey'),
                        size: $capthcaItem.attr('data-size') ? $capthcaItem.attr('data-size') : 'normal',
                        theme: $capthcaItem.attr('data-theme') ? $capthcaItem.attr('data-theme') : 'light',
                        callback: function (e) {
                            $('.recaptcha').trigger('propertychange');
                        }
                    }
                );
                $capthcaItem.after("<span class='form-validation'></span>");
            }
        };

        /**
         * @desc Initialize Bootstrap tooltip with required placement
         * @param {string} tooltipPlacement
         */
        function initBootstrapTooltip(tooltipPlacement) {
            plugins.bootstrapTooltip.tooltip('dispose');

            if (window.innerWidth < 576) {
                plugins.bootstrapTooltip.tooltip({placement: 'bottom'});
            } else {
                plugins.bootstrapTooltip.tooltip({placement: tooltipPlacement});
            }
        }

        /**
         * @desc Initialize the gallery with set of images
         * @param {object} itemsToInit - jQuery object
         * @param {string} [addClass] - additional gallery class
         */
        function initLightGallery ( itemsToInit, addClass ) {
            if ( !isNoviBuilder ) {
                $( itemsToInit ).lightGallery( {
                    thumbnail: $( itemsToInit ).attr( "data-lg-thumbnail" ) !== "false",
                    selector: "[data-lightgallery='item']",
                    autoplay: $( itemsToInit ).attr( "data-lg-autoplay" ) === "true",
                    pause: parseInt( $( itemsToInit ).attr( "data-lg-autoplay-delay" ) ) || 5000,
                    addClass: addClass,
                    mode: $( itemsToInit ).attr( "data-lg-animation" ) || "lg-slide",
                    loop: $( itemsToInit ).attr( "data-lg-loop" ) !== "false"
                } );
            }
        }

        /**
         * @desc Initialize the gallery with dynamic addition of images
         * @param {object} itemsToInit - jQuery object
         * @param {string} [addClass] - additional gallery class
         */
        function initDynamicLightGallery ( itemsToInit, addClass ) {
            if ( !isNoviBuilder ) {
                $( itemsToInit ).on( "click", function () {
                    $( itemsToInit ).lightGallery( {
                        thumbnail: $( itemsToInit ).attr( "data-lg-thumbnail" ) !== "false",
                        selector: "[data-lightgallery='item']",
                        autoplay: $( itemsToInit ).attr( "data-lg-autoplay" ) === "true",
                        pause: parseInt( $( itemsToInit ).attr( "data-lg-autoplay-delay" ) ) || 5000,
                        addClass: addClass,
                        mode: $( itemsToInit ).attr( "data-lg-animation" ) || "lg-slide",
                        loop: $( itemsToInit ).attr( "data-lg-loop" ) !== "false",
                        dynamic: true,
                        dynamicEl: JSON.parse( $( itemsToInit ).attr( "data-lg-dynamic-elements" ) ) || []
                    } );
                } );
            }
        }

        /**
         * @desc Initialize the gallery with one image
         * @param {object} itemToInit - jQuery object
         * @param {string} [addClass] - additional gallery class
         */
        function initLightGalleryItem ( itemToInit, addClass ) {
            if ( !isNoviBuilder ) {
                $( itemToInit ).lightGallery( {
                    selector: "this",
                    addClass: addClass,
                    counter: false,
                    youtubePlayerParams: {
                        modestbranding: 1,
                        showinfo: 0,
                        rel: 0,
                        controls: 0
                    },
                    vimeoPlayerParams: {
                        byline: 0,
                        portrait: 0
                    }
                } );
            }
        }


        // Adds some loosing functionality to IE browsers (IE Polyfills)
        if (isIE) {
            if (isIE === 12) $html.addClass("ie-edge");
            if (isIE === 11) $html.addClass("ie-11");
            if (isIE < 10) $html.addClass("lt-ie-10");
            if (isIE < 11) $html.addClass("ie-10");
        }

        // Bootstrap Tooltips
        if (plugins.bootstrapTooltip.length) {
            var tooltipPlacement = plugins.bootstrapTooltip.attr('data-placement');
            initBootstrapTooltip(tooltipPlacement);

            $window.on('resize orientationchange', function () {
                initBootstrapTooltip(tooltipPlacement);
            })
        }

        // Popovers
        if (plugins.popover.length) {
            if (window.innerWidth < 767) {
                plugins.popover.attr('data-placement', 'bottom');
                plugins.popover.popover();
            }
            else {
                plugins.popover.popover();
            }
        }

        // Bootstrap Buttons
        if (plugins.statefulButton.length) {
            $(plugins.statefulButton).on('click', function () {
                var statefulButtonLoading = $(this).button('loading');

                setTimeout(function () {
                    statefulButtonLoading.button('reset')
                }, 2000);
            })
        }

        // Add custom styling options for input[type="radio"]
        if (plugins.radio.length) {
            for (var i = 0; i < plugins.radio.length; i++) {
                $(plugins.radio[i]).addClass("radio-custom").after("<span class='radio-custom-dummy'></span>")
            }
        }

        // Add custom styling options for input[type="checkbox"]
        if (plugins.checkbox.length) {
            for (var i = 0; i < plugins.checkbox.length; i++) {
                $(plugins.checkbox[i]).addClass("checkbox-custom").after("<span class='checkbox-custom-dummy'></span>")
            }
        }

        // UI To Top
        $().UItoTop({
            easingType: 'easeOutQuad',
            containerClass: 'ui-to-top fa fa-angle-up'
        });

        // RD Navbar
        if (plugins.rdNavbar.length) {
            var aliaces, i, j, len, value, values, responsiveNavbar;

            aliaces = ["-", "-sm-", "-md-", "-lg-", "-xl-", "-xxl-"];
            // values = [0, 576, 768, 992, 1200, 1600];
            values = [0, 576, 768, 992, 1200, 1600];
            responsiveNavbar = {};

            for (i = j = 0, len = values.length; j < len; i = ++j) {
                value = values[i];
                if (!responsiveNavbar[values[i]]) {
                    responsiveNavbar[values[i]] = {};
                }
                if (plugins.rdNavbar.attr('data' + aliaces[i] + 'layout')) {
                    responsiveNavbar[values[i]].layout = plugins.rdNavbar.attr('data' + aliaces[i] + 'layout');
                }
                if (plugins.rdNavbar.attr('data' + aliaces[i] + 'device-layout')) {
                    responsiveNavbar[values[i]]['deviceLayout'] = plugins.rdNavbar.attr('data' + aliaces[i] + 'device-layout');
                }
                if (plugins.rdNavbar.attr('data' + aliaces[i] + 'hover-on')) {
                    responsiveNavbar[values[i]]['focusOnHover'] = plugins.rdNavbar.attr('data' + aliaces[i] + 'hover-on') === 'true';
                }
                if (plugins.rdNavbar.attr('data' + aliaces[i] + 'auto-height')) {
                    responsiveNavbar[values[i]]['autoHeight'] = plugins.rdNavbar.attr('data' + aliaces[i] + 'auto-height') === 'true';
                }

                if (isNoviBuilder) {
                    responsiveNavbar[values[i]]['stickUp'] = false;
                } else if (plugins.rdNavbar.attr('data' + aliaces[i] + 'stick-up')) {
                    responsiveNavbar[values[i]]['stickUp'] = plugins.rdNavbar.attr('data' + aliaces[i] + 'stick-up') === 'true';
                }

                if (plugins.rdNavbar.attr('data' + aliaces[i] + 'stick-up-offset')) {
                    responsiveNavbar[values[i]]['stickUpOffset'] = plugins.rdNavbar.attr('data' + aliaces[i] + 'stick-up-offset');
                }
            }


            plugins.rdNavbar.RDNavbar({
                anchorNav: !isNoviBuilder,
                stickUpClone: (plugins.rdNavbar.attr("data-stick-up-clone") && !isNoviBuilder) ? plugins.rdNavbar.attr("data-stick-up-clone") === 'true' : false,
                responsive: responsiveNavbar,
                callbacks: {
                    onStuck: function () {
                        var navbarSearch = this.$element.find('.rd-search input');

                        if (navbarSearch) {
                            navbarSearch.val('').trigger('propertychange');
                        }
                    },
                    onDropdownOver: function () {
                        return !isNoviBuilder;
                    },
                    onUnstuck: function () {
                        if (this.$clone === null)
                            return;

                        var navbarSearch = this.$clone.find('.rd-search input');

                        if (navbarSearch) {
                            navbarSearch.val('').trigger('propertychange');
                            navbarSearch.trigger('blur');
                        }

                    }
                }
            });


            if (plugins.rdNavbar.attr("data-body-class")) {
                document.body.className += ' ' + plugins.rdNavbar.attr("data-body-class");
            }
        }

        // RD Search
        if (plugins.search.length || plugins.searchResults) {
            var handler = "bat/rd-search.php";
            var defaultTemplate = '<h5 class="search-title"><a target="_top" href="#{href}" class="search-link">#{title}</a></h5>' +
                '<p>...#{token}...</p>' +
                '<p class="match"><em>Terms matched: #{count} - URL: #{href}</em></p>';
            var defaultFilter = '*.html';

            if (plugins.search.length) {
                for (var i = 0; i < plugins.search.length; i++) {
                    var searchItem = $(plugins.search[i]),
                        options = {
                            element: searchItem,
                            filter: (searchItem.attr('data-search-filter')) ? searchItem.attr('data-search-filter') : defaultFilter,
                            template: (searchItem.attr('data-search-template')) ? searchItem.attr('data-search-template') : defaultTemplate,
                            live: (searchItem.attr('data-search-live')) ? searchItem.attr('data-search-live') : false,
                            liveCount: (searchItem.attr('data-search-live-count')) ? parseInt(searchItem.attr('data-search-live'), 10) : 4,
                            current: 0, processed: 0, timer: {}
                        };

                    var $toggle = $('.rd-navbar-search-toggle');
                    if ($toggle.length) {
                        $toggle.on('click', (function (searchItem) {
                            return function () {
                                if (!($(this).hasClass('active'))) {
                                    searchItem.find('input').val('').trigger('propertychange');
                                }
                            }
                        })(searchItem));
                    }

                    if (options.live) {
                        var clearHandler = false;

                        searchItem.find('input').on("input propertychange", $.proxy(function () {
                            this.term = this.element.find('input').val().trim();
                            this.spin = this.element.find('.input-group-addon');

                            clearTimeout(this.timer);

                            if (this.term.length > 2) {
                                this.timer = setTimeout(liveSearch(this), 200);

                                if (clearHandler === false) {
                                    clearHandler = true;

                                    $body.on("click", function (e) {
                                        if ($(e.toElement).parents('.rd-search').length === 0) {
                                            $('#rd-search-results-live').addClass('cleared').html('');
                                        }
                                    })
                                }

                            } else if (this.term.length === 0) {
                                $('#' + this.live).addClass('cleared').html('');
                            }
                        }, options, this));
                    }

                    searchItem.submit($.proxy(function () {
                        $('<input />').attr('type', 'hidden')
                            .attr('name', "filter")
                            .attr('value', this.filter)
                            .appendTo(this.element);
                        return true;
                    }, options, this))
                }
            }

            if (plugins.searchResults.length) {
                var regExp = /\?.*s=([^&]+)\&filter=([^&]+)/g;
                var match = regExp.exec(location.search);

                if (match !== null) {
                    $.get(handler, {
                        s: decodeURI(match[1]),
                        dataType: "html",
                        filter: match[2],
                        template: defaultTemplate,
                        live: ''
                    }, function (data) {
                        plugins.searchResults.html(data);
                    })
                }
            }
        }

        // Add class in viewport
        if (plugins.viewAnimate.length) {
            for (var i = 0; i < plugins.viewAnimate.length; i++) {
                var $view = $(plugins.viewAnimate[i]).not('.active');
                $document.on("scroll", $.proxy(function () {
                    if (isScrolledIntoView(this)) {
                        this.addClass("active");
                    }
                }, $view))
                    .trigger("scroll");
            }
        }

        // Swiper
        if (plugins.swiper.length) {
            for (var i = 0; i < plugins.swiper.length; i++) {
                var s = $(plugins.swiper[i]);
                var pag = s.find(".swiper-pagination"),
                    next = s.find(".swiper-button-next"),
                    prev = s.find(".swiper-button-prev"),
                    bar = s.find(".swiper-scrollbar"),
                    swiperSlide = s.find(".swiper-slide"),
                    autoplay = false;

                for (var j = 0; j < swiperSlide.length; j++) {
                    var $this = $(swiperSlide[j]),
                        url;

                    if (url = $this.attr("data-slide-bg")) {
                        $this.css({
                            "background-image": "url(" + url + ")",
                            "background-size": "cover"
                        })
                    }
                }

                swiperSlide.end()
                    .find("[data-caption-animate]")
                    .addClass("not-animated")
                    .end();

                s.swiper({
                    autoplay: !isNoviBuilder && $.isNumeric( s.attr('data-autoplay') ) ? s.attr('data-autoplay') : false,
                    direction: s.attr('data-direction') ? s.attr('data-direction') : "horizontal",
                    effect: s.attr('data-slide-effect') ? s.attr('data-slide-effect') : "slide",
                    speed: s.attr('data-slide-speed') ? s.attr('data-slide-speed') : 600,
                    keyboardControl: s.attr('data-keyboard') === "true",
                    mousewheelControl: s.attr('data-mousewheel') === "true",
                    mousewheelReleaseOnEdges: s.attr('data-mousewheel-release') === "true",
                    nextButton: next.length ? next.get(0) : null,
                    prevButton: prev.length ? prev.get(0) : null,
                    pagination: pag.length ? pag.get(0) : null,
                    paginationClickable: pag.length ? pag.attr("data-clickable") !== "false" : false,
                    paginationBulletRender: pag.length ? pag.attr("data-index-bullet") === "true" ? function (swiper, index, className) {
                        return '<span class="' + className + '">' + (index + 1) + '</span>';
                    } : null : null,
                    scrollbar: bar.length ? bar.get(0) : null,
                    scrollbarDraggable: bar.length ? bar.attr("data-draggable") !== "false" : true,
                    scrollbarHide: bar.length ? bar.attr("data-draggable") === "false" : false,
                    loop: isNoviBuilder ? false : s.attr('data-loop') !== "false",
                    simulateTouch: s.attr('data-simulate-touch') && !isNoviBuilder ? s.attr('data-simulate-touch') === "true" : false,
                    onTransitionStart: function (swiper) {
                        toggleSwiperInnerVideos(swiper);
                    },
                    onTransitionEnd: function (swiper) {
                        toggleSwiperCaptionAnimation(swiper);
                    },
                    onInit: function (swiper) {
                        toggleSwiperInnerVideos(swiper);
                        toggleSwiperCaptionAnimation(swiper);
                        initLightGalleryItem(s.find('[data-lightgallery="item"]'), 'lightGallery-in-carousel');
                    }
                });
            }
        }

        // Owl carousel
        if ( plugins.owl.length ) {
            for ( var i = 0; i < plugins.owl.length; i++ ) {
                var carousel = $( plugins.owl[ i ] );
                plugins.owl[ i ].owl = carousel;
                initOwlCarousel( carousel );
            }
        }

        // WOW
        if ($html.hasClass("wow-animation") && plugins.wow.length && !isNoviBuilder && isDesktop) {
            new WOW().init();
        }

        // RD Input Label
        if (plugins.rdInputLabel.length) {
            plugins.rdInputLabel.RDInputLabel();
        }

        // Regula
        if (plugins.regula.length) {
            attachFormValidator(plugins.regula);
        }

        // RD Mailform
        if (plugins.rdMailForm.length) {
            var i, j, k,
                msg = {
                    'MF000': 'Erfolgreich gesendet',
                    'MF001': 'Recipients are not set!',
                    'MF002': 'Form will not work locally!',
                    'MF003': 'Please, define email field in your form!',
                    'MF004': 'Please, define type of your form!',
                    'MF254': 'Something went wrong with PHPMailer!',
                    'MF255': 'Aw, snap! Something went wrong.'
                };

            for (i = 0; i < plugins.rdMailForm.length; i++) {
                var $form = $(plugins.rdMailForm[i]),
                    formHasCaptcha = false;

                $form.attr('novalidate', 'novalidate').ajaxForm({
                    data: {
                        "form-type": $form.attr("data-form-type") || "contact",
                        "counter": i
                    },
                    beforeSubmit: function (arr, $form, options) {
                        if (isNoviBuilder)
                            return;

                        var form = $(plugins.rdMailForm[this.extraData.counter]),
                            inputs = form.find("[data-constraints]"),
                            output = $("#" + form.attr("data-form-output")),
                            captcha = form.find('.recaptcha'),
                            captchaFlag = true;

                        output.removeClass("active error success");

                        if (isValidated(inputs, captcha)) {

                            // veify reCaptcha
                            if (captcha.length) {
                                var captchaToken = captcha.find('.g-recaptcha-response').val(),
                                    captchaMsg = {
                                        'CPT001': 'Please, setup you "site key" and "secret key" of reCaptcha',
                                        'CPT002': 'Something wrong with google reCaptcha'
                                    };

                                formHasCaptcha = true;

                                $.ajax({
                                    method: "POST",
                                    url: "bat/reCaptcha.php",
                                    data: {'g-recaptcha-response': captchaToken},
                                    async: false
                                })
                                    .done(function (responceCode) {
                                        if (responceCode !== 'CPT000') {
                                            if (output.hasClass("snackbars")) {
                                                output.html('<p><span class="icon text-middle mdi mdi-check icon-xxs"></span><span>' + captchaMsg[responceCode] + '</span></p>')

                                                setTimeout(function () {
                                                    output.removeClass("active");
                                                }, 3500);

                                                captchaFlag = false;
                                            } else {
                                                output.html(captchaMsg[responceCode]);
                                            }

                                            output.addClass("active");
                                        }
                                    });
                            }

                            if (!captchaFlag) {
                                return false;
                            }

                            form.addClass('form-in-process');

                            if (output.hasClass("snackbars")) {
                                output.html('<p><span class="icon text-middle fa fa-circle-o-notch fa-spin icon-xxs"></span><span>Sending</span></p>');
                                output.addClass("active");
                            }
                        } else {
                            return false;
                        }
                    },
                    error: function (result) {
                        if (isNoviBuilder)
                            return;

                        var output = $("#" + $(plugins.rdMailForm[this.extraData.counter]).attr("data-form-output")),
                            form = $(plugins.rdMailForm[this.extraData.counter]);

                        output.text(msg[result]);
                        form.removeClass('form-in-process');

                        if (formHasCaptcha) {
                            grecaptcha.reset();
                        }
                    },
                    success: function (result) {
                        if (isNoviBuilder)
                            return;

                        var form = $(plugins.rdMailForm[this.extraData.counter]),
                            output = $("#" + form.attr("data-form-output")),
                            select = form.find('select');

                        form
                            .addClass('success')
                            .removeClass('form-in-process');

                        if (formHasCaptcha) {
                            grecaptcha.reset();
                        }

                        result = result.length === 5 ? result : 'MF255';
                        output.text(msg[result]);

                        if (result === "MF000") {
                            if (output.hasClass("snackbars")) {
                                output.html('<p><span class="icon text-middle mdi mdi-check icon-xxs"></span><span>' + msg[result] + '</span></p>');
                            } else {
                                output.addClass("active success");
                            }
                        } else {
                            if (output.hasClass("snackbars")) {
                                output.html(' <p class="snackbars-left"><span class="icon icon-xxs mdi mdi-alert-outline text-middle"></span><span>' + msg[result] + '</span></p>');
                            } else {
                                output.addClass("active error");
                            }
                        }

                        form.clearForm();

                        if (select.length) {
                            select.select2("val", "");
                        }

                        form.find('input, textarea').trigger('blur');

                        setTimeout(function () {
                            output.removeClass("active error success");
                            form.removeClass('success');
                        }, 3500);
                    }
                });
            }
        }

        // lightGallery
        if (plugins.lightGallery.length) {
            for (var i = 0; i < plugins.lightGallery.length; i++) {
                initLightGallery(plugins.lightGallery[i]);
            }
        }

        // lightGallery item
        if (plugins.lightGalleryItem.length) {
            // Filter carousel items
            var notCarouselItems = [];

            for (var z = 0; z < plugins.lightGalleryItem.length; z++) {
                if (!$(plugins.lightGalleryItem[z]).parents('.owl-carousel').length &&
                    !$(plugins.lightGalleryItem[z]).parents('.swiper-slider').length &&
                    !$(plugins.lightGalleryItem[z]).parents('.slick-slider').length) {
                    notCarouselItems.push(plugins.lightGalleryItem[z]);
                }
            }

            plugins.lightGalleryItem = notCarouselItems;

            for (var i = 0; i < plugins.lightGalleryItem.length; i++) {
                initLightGalleryItem(plugins.lightGalleryItem[i]);
            }
        }

        // Dynamic lightGallery
        if (plugins.lightDynamicGalleryItem.length) {
            for (var i = 0; i < plugins.lightDynamicGalleryItem.length; i++) {
                initDynamicLightGallery(plugins.lightDynamicGalleryItem[i]);
            }
        }

        // Custom Toggles
        if (plugins.customToggle.length) {
            for (var i = 0; i < plugins.customToggle.length; i++) {
                var $this = $(plugins.customToggle[i]);

                $this.on('click', $.proxy(function (event) {
                    event.preventDefault();

                    var $ctx = $(this);
                    $($ctx.attr('data-custom-toggle')).add(this).toggleClass('active');
                }, $this));

                if ($this.attr("data-custom-toggle-hide-on-blur") === "true") {
                    $body.on("click", $this, function (e) {
                        if (e.target !== e.data[0]
                            && $(e.data.attr('data-custom-toggle')).find($(e.target)).length
                            && e.data.find($(e.target)).length === 0) {
                            $(e.data.attr('data-custom-toggle')).add(e.data[0]).removeClass('active');
                        }
                    })
                }

                if ($this.attr("data-custom-toggle-disable-on-blur") === "true") {
                    $body.on("click", $this, function (e) {
                        if (e.target !== e.data[0] && $(e.data.attr('data-custom-toggle')).find($(e.target)).length === 0 && e.data.find($(e.target)).length === 0) {
                            $(e.data.attr('data-custom-toggle')).add(e.data[0]).removeClass('active');
                        }
                    })
                }
            }
        }

        // JQuery mousewheel plugin
        if (plugins.scroller.length) {
            for (var i = 0; i < plugins.scroller.length; i++) {
                var scrollerItem = $(plugins.scroller[i]);

                scrollerItem.mCustomScrollbar({
                    theme: scrollerItem.attr('data-theme') ? scrollerItem.attr('data-theme') : 'minimal',
                    scrollInertia: 100,
                    scrollButtons: {enable: false}
                });
            }
        }

        // Stepper
        if (plugins.stepper.length) {
            plugins.stepper.stepper({
                labels: {
                    up: "",
                    down: ""
                }
            });
        }

        // Slick carousel
        if (plugins.slick.length) {
            for (var i = 0; i < plugins.slick.length; i++) {
                var $slickItem = $(plugins.slick[i]);

                $slickItem.on('init', function (slick) {
                    initLightGallery($('[data-lightgallery="group-slick"]'), 'lightGallery-in-carousel');
                    initLightGallery($('[data-lightgallery="item-slick"]'), 'lightGallery-in-carousel');
                });

                $slickItem.slick({
                    slidesToScroll: parseInt($slickItem.attr('data-slide-to-scroll'), 10) || 1,
                    asNavFor: $slickItem.attr('data-for') || false,
                    dots: $slickItem.attr("data-dots") === "true",
                    infinite: isNoviBuilder ? false : $slickItem.attr("data-loop") === "true",
                    focusOnSelect: true,
                    arrows: $slickItem.attr("data-arrows") === "true",
                    swipe: $slickItem.attr("data-swipe") === "true",
                    autoplay: $slickItem.attr("data-autoplay") === "true",
                    vertical: $slickItem.attr("data-vertical") === "true",
                    centerMode: $slickItem.attr("data-center-mode") === "true",
                    centerPadding: $slickItem.attr("data-center-padding") ? $slickItem.attr("data-center-padding") : '0.50',
                    mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: 0,
                            settings: {
                                slidesToShow: parseInt($slickItem.attr('data-items'), 10) || 1
                            }
                        },
                        {
                            breakpoint: 575,
                            settings: {
                                slidesToShow: parseInt($slickItem.attr('data-sm-items'), 10) || 1
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: parseInt($slickItem.attr('data-md-items'), 10) || 1
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: parseInt($slickItem.attr('data-lg-items'), 10) || 1
                            }
                        },
                        {
                            breakpoint: 1199,
                            settings: {
                                slidesToShow: parseInt($slickItem.attr('data-xl-items'), 10) || 1
                            }
                        }
                    ]
                })
                    .on('afterChange', function (event, slick, currentSlide, nextSlide) {
                        var $this = $(this),
                            childCarousel = $this.attr('data-child');

                        if (childCarousel) {
                            $(childCarousel + ' .slick-slide').removeClass('slick-current');
                            $(childCarousel + ' .slick-slide').eq(currentSlide).addClass('slick-current');
                        }
                    });

            }
        }

    });
}());

$(document).ready(function() {
    if ($('#mainmenu').length > 0) {
        $('.rd-nav-item').on('click', function() {
            $('.rd-nav-item').removeClass('active');
            $(this).addClass('active');
        });
    }

    $('.closingSubmenu, nav.rd-navbar a.rd-nav-link').on('click', function() {
        $('#mainBurger').click();
    });
});

function updateNotificationSessionData(values,tokenValue) {
    $.ajax({
        url: basePath+'/updateNotification',
        type: 'post',
        data: {
            tokenId: document.querySelector('#notificationsFCMID').value,
            concertsThisWeek: document.querySelector('#concertsThisWeek').checked,
            thisWeekendFriday: document.querySelector('#thisWeekendFriday').checked,
            thisWeekendSaturday: document.querySelector('#thisWeekendSaturday').checked,
            recommendations: document.querySelector('#recommendations').checked,
            _token: tokenValue
        },
        dataType: 'json',
        success: function (response) {
            localStorage.setItem("concertsThisWeek",""+document.querySelector('#concertsThisWeek').checked);
            localStorage.setItem("thisWeekendFriday",document.querySelector('#thisWeekendFriday').checked);
            localStorage.setItem("thisWeekendSaturday",document.querySelector('#thisWeekendSaturday').checked);
            localStorage.setItem("recommendations",document.querySelector('#recommendations').checked);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            alert(xhr.status);
            alert(thrownError);
        }
    });
}

